@let disabled = !open && !canClick;

<span
    role="heading"
    aria-level="2"
>
    <button
        [id]="'toggle-' + orderStep.slug"
        class="toggle"
        [attr.aria-expanded]="open"
        [attr.aria-disabled]="disabled"
        [ngClass]="{
            '-clickable': canClick,
            '-open': open,
            '-disabled': disabled,
            '-valid': complete,
            '-invalid': !!(isInvalid && complete),
        }"
        [tabindex]="canClick ? 0 : -1"
        (click)="toggleClicked()"
    >
        <div class="text m-6:h">
            <span>Schritt {{ stepCounter }}</span>
            <h2 class="m-0">{{ orderStep.title }}</h2>
        </div>
        @if (open || canClick) {
            <i
                class="accordion-icon"
                ctrlIcon="chevron_right"
            ></i>
        }
    </button>
</span>
<div [ngClass]="{ 'p-8:h sm:p-24:h md:p-36:h p-32:t': open }">
    <ng-template appStepHost></ng-template>
</div>
